export const alert = {
    namespaced: true,
    state: {
        type: null,
        message: null
    },
    mutations: {
        success: (state, message) => {
            state.type = 'success';
            state.message = message;
        },
        info: (state, message) => {
            state.type = 'info';
            state.message = message;
        },
        error: (state, message) => {
            state.type = 'danger';
            state.message = message;
        },
        clear: state => {
            state.type = null;
            state.message = null;
        }
    },
    actions: {
        success: ({ commit }, message) => {
            console.log('Store[Alert]: Success => %s', message);
            commit('success', message);
        },
        info: ({ commit }, message) => {
            console.log('Store[Alert]: Info => %s', message);
            commit('info', message);
        },
        error: ({ commit }, message) => {
            console.log('Store[Alert]: Error => %s', message);
            commit('error', message);
        },
        exception: ({ commit }, { err, message }) => {
            console.log('Store[Alert]: Exception => Err[%s] Message[%s]', err && err.data ? JSON.stringify(err.data) : err, message);

            // check for JWT or license error and ignore it as router will re-direct the user
            let status = err && err.status ? err.status : null;
            if (status === 401 || status === 402 || status === 403 || status === 460) {
                console.log('Store[Alert]: Exception => JWT or license error, ignoring alert!!');
                return;
            }

            // log the most appropriate error message
            if (err && err.data && err.data.message && err.data.message.length > 0) {
                commit('error', err.data.message);
            } else if (err && err.message && err.message.length > 0) {
                commit('error', err.message);
            } else {
                commit('error', message);
            }
        },
        clear: ({ commit }) => {
            console.log('Store[Alert]: Clear');
            commit('clear');
        }
    }
}